import { useState, useContext } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import _get from 'lodash/get';
import { AjaxContext, AppContext } from 'commons-ui';
import dayjs from 'dayjs';

const useEdit = () => {
	const [showLoader, setShowLoader] = useState(false);
	const history = useHistory();
	const location = useLocation();
	const { postData } = useContext(AjaxContext);
	const {
		app: { appName },
		showAlert
	} = useContext(AppContext);

	const goToListPage = () => {
		history.push({
			pathname: '/dashboard/scheduledDowntime/list'
		});
	};

	const getEditForData = () => {
		const editData: any = _get(location?.state, 'rowData', {});
		if (editData) {
			editData.startTime = editData?.begin;
			editData.endTime = editData?.end;

			return editData;
		}
		goToListPage();
		return {};
	};

	const handleFormSubmit = async (submittedData: any) => {
		try {
			const editData = getEditForData();
			let startTime: string | null = submittedData?.startTime;
			let endTime: string | null = submittedData?.endTime;
			setShowLoader(true);
			if (typeof submittedData?.startTime === 'number')
				startTime = dayjs(new Date(Number(submittedData?.startTime))).format('YYYY-MM-DD HH:mm:ss');

			if (typeof submittedData?.endTime === 'number')
				endTime = dayjs(new Date(Number(submittedData?.endTime))).format('YYYY-MM-DD HH:mm:ss');
			const response = await postData({
				endpoint: '/marketing/dashboard/downtime/updateDowntimeDetails',
				queryParams: {
					appName
				},
				body: {
					constraintId: editData?.constraintId,
					isActive: submittedData?.isActive,
					startTime,
					endTime,
					message: submittedData?.message
				}
			});
			const err: boolean = response?.data && response?.data?.success;
			if (!err) {
				showAlert(`Error: Scheduled Downtime updating failed, please try again.`, { type: 'error' });
			} else {
				showAlert('Record updated');
				goToListPage();
			}
		} catch (error) {
			showAlert(`Error: Scheduled Downtime update failed, please try again.`, { type: 'error' });
		} finally {
			setShowLoader(false);
		}
	};

	const handleFormCancel = () => {
		goToListPage();
	};

	return { showLoader, handleFormSubmit, handleFormCancel, setShowLoader, data: getEditForData() };
};

export default useEdit;
